<template>
  <div class="overlay">
    <div class="overlay_inner channel_change">

      <p class="field">
        <multiselect-searchbox
            :searchFunction="searchChannels"
            v-model="id_channels_to"
            :show-id="true"
            name="selectchannelmultiselect"
            id="selectchannelid"
        >
          Vyměnit kanál {{ popupData.name }} za kanály
        </multiselect-searchbox>
      </p>

      <p class="field">
        <p>Výměna kanálů bude provedena ihned po stisku tlačítka v tomto modalním okně.</p>
      </p>

      <p class="buttons">
        <a class="btn" @click.stop.prevent="emitAction" v-translate>Vyměnit</a>
      </p>

      <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="emitClose" v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "ServiceReplaceChannelPopup",
  mixins: [requiredFields],
  props: {
    popupData: Object,
  },
  data() {
    return {
      id_channels_to: [],
      channelOptions: this.popupData.channels
          .filter(c => {
            return c.id_type === this.popupData.channelType
          })
          .map(c => ({ id: c.id, text: c.name }))
    }
  },
  methods: {
    emitAction() {
      let id_channel_from = this.popupData.id
      this.$emit('replace', { id_channel_from, id_channels_to: this.id_channels_to })
    },
    emitClose() {
      this.$emit('close-popup')
    },
    searchChannels(search, selectAll = false) {
      let options = selectAll ? this.channelOptions : this.channelOptions.filter(c => this.localeContains(search, c.text) || c.id === search)
      return Promise.resolve({ data: options })
    },
    localeContains(needle, haystack) {
      // https://stackoverflow.com/questions/39548303/javascript-string-prototype-contains-with-locale#answer-69623589
      if (needle === '') return true;
      if (!needle || !haystack.length) return false;
      needle = '' + needle;
      if (needle.length > haystack.length) return false;
      let ascii = s => s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      return ascii(haystack).includes(ascii(needle));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ServiceReplaceChannelPopup.vue